import './App.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header/Header'
import Home from './pages/Home/Home'
import About from './pages/About/About'
import Products from './pages/Products/Products'
import Contact from './pages/Contact/Contact'
import { Footer } from './components/Footer/Footer'
import { QuoteModal } from './components/QuoteModal/QuoteModal'
import { QuoteProvider } from './context/QuoteContext'

function AppContent() {
	return (
		<>
			<div>
				<Router>
					<Header />
					<Routes>
						<Route path='/' element={<Home />} />
						<Route path='/about' element={<About />} />
						<Route path='/products' element={<Products />} />
						<Route path='/contact' element={<Contact />} />
					</Routes>
					<Footer />
				</Router>
			</div>
			<QuoteModal />
		</>
	)
}

export default function App() {
	return (
		<QuoteProvider>
			<AppContent />
		</QuoteProvider>
	)
}
